import api from '@api/api';
import { LandingPageTemplate } from '@customTypes/Entities';
import useFetchAll from '@hooks/useFetchAll';

const useLandingPageTemplats = (date?: string) => {
  const { data, isFetching, error, ...rest } = useFetchAll<LandingPageTemplate>({
    queryKeyRoot: 'landing-page-templates',
    apiFn: (params) => api.getLandingPageTemplates(params),
    date,
  });

  return { landingPageTemplates: data, isFetching, error, ...rest };
};

export default useLandingPageTemplats;
